import React from "react";
import { ReactComponent as BackIcon } from "assets/img/svg/BackButton.svg";
import CustomChip from "views/pages/manage/common/customChip/CustomChip.jsx";
import IconButtonWrapper from "../../../../views/pages/manage/common/form-fields-mui/IconButtonWrapper";

export const RenderHeaderChip = ({ label, value, children, style = {}, className = "" }) => {
  return (
    <CustomChip
      bgColor={style.background || "#F5F5F5"}
      textColor={style.color || "#262626"}
      style={{ ...style }}
      className={className}
    >
      {label}: <span className="text-bold">{value}</span>
      {children}
    </CustomChip>
  );
};

const ModuleHeaderBar = ({
  title,
  showBack = true,
  onBackClick = () => window.close(),
  headerData = {},
  chipStyle = {},
  className = "",
  children
}) => {
  // Convert dynamic object into chip structure
  const chips = Object.keys(headerData).map(key => ({
    label: key, 
    value: headerData[key]
  }));

  return (
    <div
      className={`d-flex align-items-center justify-content-between w-100 p-2 ${className}`}
      style={{ borderBottom: "1.5px solid #E2E2E2", paddingBottom: "8px" }}
    >
      <div className="d-flex align-items-center gap-md">
        {showBack && (
          <IconButtonWrapper onClick={onBackClick}>
            <BackIcon />
          </IconButtonWrapper>
        )}
        <div className="heading-5 text-bold text-dark">{title}</div>
      </div>

      <div className="d-flex align-items-center flex-wrap gap-md">
        {chips.map((chip, i) => (
          <RenderHeaderChip
            key={i}
            label={chip.label}
            value={chip.value}
            style={{ ...chipStyle }}
            className="body-regular global-font-size"
          >
            {chip.children}
          </RenderHeaderChip>
        ))}
        {children}
      </div>
    </div>
  );
};

export default ModuleHeaderBar;
